import './App.css';
import './PageMarketingV2PresentTablets.css';
import { Button } from 'primereact/button';
import TotemTablet from './TotemTablet';

function PageMarketingV2PresentTablets({ creativeURL }) {
    return (
        <div
            className='mk2-dark'
            align='center'
        >
            <div className='mk2-title'>
                Desk Tablets
            </div>
            <div className='mk2-present-tablets'>
                <div>
                    <div className='mk2-subtitle-small-right'>
                        Elevate your shop's appeal with our desk tablets—effortlessly display vibrant ads, fusing style and advertising prowess in a compact device.
                    </div>
                    <div>
                        <div className='mk2-subtitle-right'>
                            <b>
                                Starting from
                            </b>
                        </div>
                        <div className='mk2-title-right'>
                            9.9 EUR / month
                        </div>
                        <div
                            align='right'
                        >
                            <Button
                                label="View Offers"
                                severity="success"
                                outlined
                                size='small'
                            />
                        </div>
                    </div>
                </div>
                <TotemTablet
                    creativeURL={creativeURL}
                />
            </div>
        </div>
    )
}

export default PageMarketingV2PresentTablets;